<template>
  <SCAInputWrapper
    :label="label"
    :label-position="labelPosition"
    :appearance="appearance"
    :helper-text="helperText"
    :optional-label-text="optionalLabelText"
    :validation-error="validationError"
    :required="required"
    :html-for="htmlFor"
    :highlight-label="highlightLabel"
    :tooltip-type
    :tooltip-id
    :tooltip
    :help-link="helpLink"
  >
    <template #labelActionWrapper>
      <slot name="labelAction" />
    </template>
    <template #labelIcon>
      <slot name="labelIcon" />
    </template>

    <div :class="[$style.inputWrapper, { [$style.hasPrefixIcon]: slots.prefixIcon }]">
      <SCAInputBase :alert="validationError" :appearance :focused>
        <template v-if="prefix !== undefined" #before>
          <div :class="$style.prefix">
            {{ prefix }}
          </div>
        </template>

        <slot />
      </SCAInputBase>

      <div v-if="slots.prefixIcon" :class="$style.prefixIcon">
        <slot name="prefixIcon" />
      </div>
    </div>
  </SCAInputWrapper>
</template>

<script setup lang="ts">
import { useSlots } from "vue";

import SCAInputBase from "./SCAInputBase.vue";
import SCAInputWrapper from "./SCAInputWrapper.vue";
import type { SCAInputProps } from "./types";

withDefaults(defineProps<SCAInputProps>(), {
  label: undefined,
  labelPosition: undefined,
  appearance: undefined,
  helperText: undefined,
  optionalLabelText: undefined,
  htmlFor: undefined,
  validationError: false,
  required: false,
  prefix: undefined,
  highlightLabel: false,
  tooltipType: "default",
  tooltipId: undefined,
  tooltip: undefined,
  helpLink: undefined,
  focused: false,
});

const slots = useSlots();
</script>

<style module lang="scss">
@use "../styles/icon.scss" as IconMixins;

.inputWrapper {
  position: relative;
  width: 100%;
  display: grid;
}

.prefix {
  padding: 0 var(--space-component-padding-small);
  align-self: stretch;
  align-content: center;
  color: var(--color-content-tertiary);
  background-color: var(--color-background-neutral-subtle);
  white-space: nowrap;
}

.prefixIcon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  & svg {
    @include IconMixins.icon-color(var(--color-content-tertiary));
  }
}

.hasPrefixIcon input {
  padding-left: var(--space-component-padding-large);
}
</style>
